import * as React from 'react';

import AlertDialog from 'components/AlertDialog';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';
import { Schools } from 'organizations/components/OrganizationEngagementView/OrganizationEngagementViewDataContainer';

import './OrganizationEngagementSchoolsModal.scss';

type Props = {
  name: string | undefined;
  onRequestHide?: () => void;
  schools: Schools | undefined;
};

export default function OrganizationEngagementSchoolsModal({
  name,
  onRequestHide,
  schools,
}: Props) {
  if (!schools) return null

  return (
    <AlertDialog
      image={require('./images/badges.svg')}
      title={(
        <Text font="serif" size="xxlarge">
          School engagement across {name}
        </Text>
      )}
      subtext={
        <React.Fragment>
          Click on a school to see its rating, community engagement statistics, and strategies for improving engagement.
          {' '}
          <Link to={LinkConstants.ENGAGEMENT_RATINGS_HC_NO_RATING} weight="semibold">
            Why can’t I find a school?
          </Link>
        </React.Fragment>
      }
      buttonText="Done"
      size="large"
      onOkay={onRequestHide}
      onRequestHide={onRequestHide}
      className="OrganizationEngagementSchoolsModal">
      <div className="OrganizationEngagementSchoolsModal-schools">
        <Text align="left" element="div" size="small">
          {schools.map((item) => (
            <Row key={item.slug} size="xxsmall">
              <Link to={`/school/${item.slug}`} weight="semibold">{item.name}</Link>
            </Row>
          ))}
        </Text>
      </div>
    </AlertDialog>
  );
}

